import React, {useEffect, useState} from 'react'
import {createPortal} from 'react-dom'

const Portal = ({children, containerId = 'portal-root'}) => {
    const [container, setContainer] = useState(null)

    useEffect(() => {
        // Find existing container or create a new one
        let portalContainer = document.getElementById(containerId)

        if (!portalContainer) {
            portalContainer = document.createElement('div')
            portalContainer.id = containerId
            document.body.appendChild(portalContainer)
        }

        setContainer(portalContainer)

        // Cleanup function to remove the container if we created it
        return () => {
            if (portalContainer.childNodes.length === 0) {
                document.body.removeChild(portalContainer)
            }
        }
    }, [containerId])

    return container ? createPortal(children, container) : null
}

export default Portal

